function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "pencil-icon",
  d: "M17.9 4.5l1.6 1.6c.6.6.6 1.7 0 2.3l-.8.8-3.9-3.9.8-.8c.6-.7 1.7-.7 2.3 0zM4 20l.6-2.3.6-2.3 1.7 1.7 1.7 1.7-2.3.6L4 20zm13.9-10L14 6.1l-8.2 8.2 3.9 3.9 8.2-8.2z",
  fillRule: "evenodd",
  clipRule: "evenodd"
});

var SvgPencil = function SvgPencil(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgPencil;